import { BrowserRouter } from 'react-router-dom';
import AppRouter, { AppRouterProps } from './AppRouter';

export default AppRouter;
export { BrowserRouter as AppRouterProvider };
export type { AppRouterProps };
